<template>
  <div ref="chartContainer"></div>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'GaugeChart',
  props: {
    width: {
      type: Number,
      default: 50,
    },
    foregroundColor: {
      type: String,
      default: '#7CCDA2',
    },
    backgroundColor: {
      type: String,
      default: '#e7e7e7',
    },
    value: {
      type: Number,
      required: true,
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.updateChart(newValue);
      },
      immediate: true,
    },
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      if (!this.$refs.chartContainer) {
        return;
      }

      d3.select(this.$refs.chartContainer).selectAll('*').remove();

      const width = this.width;
      const height = width;
      const outerRadius = width / 2 - 10;
      const innerRadius = outerRadius * 0.6;
      const tau = 2 * Math.PI;

      this.svg = d3
        .select(this.$refs.chartContainer)
        .append('svg')
        .attr('viewBox', `0 0 ${width} ${height}`)
        .attr('width', width)
        .attr('height', height)
        .style('overflow', 'visible');

      this.g = this.svg
        .append('g')
        .attr('transform', `translate(${width / 2}, ${height / 2})`);

      this.arc = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(outerRadius)
        .startAngle(0);

      this.g
        .append('path')
        .datum({ endAngle: tau })
        .style('fill', this.backgroundColor)
        .attr('d', this.arc);

      this.foreground = this.g
        .append('path')
        .datum({ endAngle: 0 })
        .style('fill', this.foregroundColor)
        .attr('d', this.arc);

      this.updateChart(this.value);
    },
    updateChart(value) {
      if (!this.foreground) {
        console.warn('Foreground is not initialized yet');
        return;
      }

      const tau = 2 * Math.PI;
      const endAngle = (value / 100) * tau;
      this.foreground
        .transition()
        .duration(750)
        .attrTween('d', this.arcTween(this.arc, endAngle));
    },
    arcTween(arc, newAngle) {
      return function (d) {
        const interpolate = d3.interpolate(d.endAngle, newAngle);
        return function (t) {
          d.endAngle = interpolate(t);
          return arc(d);
        };
      };
    },
  },
};
</script>

<style></style>
